<script lang="ts">
  import {createEventDispatcher, getContext} from 'svelte';
  import {Button, Modal} from '@/widgets';
  import lang from './common.lang';
  import {fixLink$} from '@/store';
  import {PATHS} from '@/const';
  import {gotoOneClickPlaceOrderPage} from '@/modules/fiat/one-click-transaction/utils';
  import {numUtil} from '@/helper';

  const dispatch = createEventDispatcher();
  const LG = getContext('LG');
  export let info;

  function handleCloseEvent() {
    dispatch('close');
  }

  function handleViewAssetsClick() {
    window.location.replace($fixLink$(PATHS.ASSETS_FIAT_ACCOUNT.pathname));
  }

  function handleBuyCryptoClick() {
    gotoOneClickPlaceOrderPage({side: 'buy'}, {replaceURL: true});
  }
</script>

<Modal visible showCloseIcon2 style="width: 480px;" on:close={handleCloseEvent}>
  <div class="deposit-success">
    <div class="df aic jcc">
      <img src="https://img.phemex.com/v1/1bf18a48/success-2x-1.png" width="72" height="72" alt="success" srcset="" />
    </div>
    <h1 class="p0 mt24 tc f20 lh24 b T1">{LG(lang.FiatDepositSuccessfully)}</h1>
    <div class="introduction mt12 tc f16 lh24 T3">{@html LG(lang.YourFiatDeposit, {
      Amount: `<span class="T1 b">${numUtil.delimit(info?.fiatAmount || '0')}</span>`,
      Unit: `<span class="T1 b">${numUtil.delimit(info?.fiatCurrency || '')}</span>`
    })}</div>
    <div class="df fdr aic mt24" style="gap: 10px">
      <Button newRadius type="default" class="f1 f16 b wp100" style='color: #003FE6;border-color: #003FE6' on:click={handleViewAssetsClick}>
        {LG(lang.ViewAssets)}
      </Button>
      <Button newRadius type="primary" class="f1 f16 b wp100" style='margin: 0' on:click={handleBuyCryptoClick}>
        {LG(lang.BuyCrypto)}
      </Button>
    </div>
  </div>
</Modal>
